import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "payment-requests-header-additional" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 7h6v6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m22 7-8.5 8.5-5-5L2 17" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 17h6v-6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m22 17-8.5-8.5-5 5L2 7" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 6v6l4 2" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21.801 10A10 10 0 1 1 17 3.335" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m9 11 3 3L22 4" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_statistic = _resolveComponent("bs-statistic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_bs_statistic, {
            label: "Всего",
            value: _ctx.total
          }, {
            icon: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_bs_statistic, {
            label: "Расходы",
            value: _ctx.formatPriceToTenge(_ctx.expenses),
            color: "red"
          }, {
            icon: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_bs_statistic, {
            label: "Ожидают",
            value: _ctx.waiting,
            color: "orange"
          }, {
            icon: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_bs_statistic, {
            label: "Выплачено",
            value: _ctx.paid,
            color: "green"
          }, {
            icon: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["value"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}